import DataTable from "../../1. Core/Controls/DataTable/DataTable";
import Control from "../../1. Core/Control";
import NP from "../../1. Core/NP";
import {PackCard} from "../types";
import { ServerAPI } from "../../1. Core/ServerAPI";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";
import Menu from "../../1. Core/Controls/Menu/Menu";
import Delegate from "../../1. Core/Delegate";
import EditPackCardDialog from "./EditPackCardDialog";
import ListItem from "../../1. Core/Controls/ListBox/ListItem";

export default class PackCardTable extends Control {
    private _dataTable: DataTable;
    private _topAppBar: TopAppBar;
    private _PackId: number;
    private EvBackClick: Delegate;

    constructor(settings: object) {
        super(settings);
        this._render();
    }

    _initFields(settings: object) {
        this._PackId = null
        this.EvBackClick = new Delegate();
        super._initFields(settings);
    }

    getTopAppBar(){
        return this._topAppBar;
    }

    _render() {
        this.np_render();
        this.addClass('');
        this._topAppBar = new TopAppBar({
            Caption: "Cards of pack " + this._PackId,
            Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
            ParentNode: this._root,
            ShowSearchButton: false,
            RightItems: NP.getCurrentUser().isBDAdmin() ? [
                new IconToggleButton({
                    FontImage: NP.FontImages.add,
                    EvClick: () => new EditPackCardDialog({
                        PackId: this._PackId,
                        EvOkButtonClick: () => this.refresh()
                    }).show()
                }),
            ] : [],
            EvBackClick: () => this.EvBackClick.fire(this)
        });
        this._topAppBar.setShowBackButton(true);

        this._dataTable = new DataTable({
            ParentNode: this._root,
            Columns: [
                { Content: "Id", PropertyContent: "id", Width: "10%" },
                { Content: "Row", PropertyContent: "grid_row", Width: "10%" },
                { Content: "Column", PropertyContent: "grid_col", Width: "10%" },
                { Content: "Name EN", PropertyContent: "name_en", Width: "20%" },
                { Content: "Name RU", PropertyContent: "name_ru", Width: "20%" },
                { Content: "Name ES", PropertyContent: "name_es", Width: "20%" },
                { Content: "Name PT", PropertyContent: "name_pt", Width: "20%" },
                { Content: "Description", PropertyContent: "description", Width: "20%" },
                { Content: "Background", PropertyContent: "background_color", Width: "20%" },
            ],
            ShowSettingsButton: true,
            EvItemContextMenu: async (s: any, e: { Event: any, Item: PackCard }) => {
                let menu = new Menu({
                    Items: [
                        { FontImage: NP.FontImages.edit, RK: "Edit", Value: "Edit" },
                        { FontImage: NP.FontImages.delete, RK: "Remove", Value: "Remove" },
                    ],
                    EvItemSelected: async (s: Menu, event: { Item: ListItem }) => {
                        switch (event.Item.getValue()) {
                            case "Edit":
                                new EditPackCardDialog({
                                    PackCard: e.Item,
                                    EvOkButtonClick: () => this.refresh()
                                }).show();
                                break;
                            case "Remove":
                                NP.showConfirm({
                                    Content: "Delete?",
                                    EvOkButtonClick: async () => {
                                        await ServerAPI.delet("/fantasy/card-collections/cards/" + e.Item.id);
                                        this.refresh();
                                    }
                                });
                                break;
                        }
                    }
                });
                menu.showContextMenu(e.Event);
            }
        });

        this.refresh();
    }

     async refresh() {
        let items = await ServerAPI.get<PackCard[]>(`/fantasy/card-collections/cards?packId=${this._PackId}`);
        this._dataTable.setRows(items);
    }
}